{
  "en": {
    "name": "English",
    "type": "en-EN",
    "language": "Language",
    "UI": {
      "Home": "Home",
      "TransparencyVis": "TransparencyVis",
      "About": "About",
      "Collapse": "Collapse",
      "Expand": "Expand",
      "ConfigSidebar": "Filters & Settings",
      "ExpandConfigSidebar": "Expand Advanced Configuration",
      "Imprint": "Imprint",
      "PrivacyPolicy": "Privacy Policy",
      "Settings": "Settings",
      "NotFound": "Location not found",
      "Wrangler": "Data Wrangler",
      "Explore": "Go to Visualizations",
      "NextVisualization": "Next Visualization",
      "PreviousVisualization": "Previous Visualization",
      "AddData": "Add More Data",
      "Help": "Help",
      "VisualizationHelp": "Get information about this visualization"
    },
    "LandingPage": {
      "About": "About the project",
      "AboutDevelopment": "TransparencyVis is developed by the Competence Center for <a href='https://www.igd.fraunhofer.de/kompetenzen/technologien/informationsvisualisierung'>Information Visualization and Visual Analytics</a> at the <a href='https://www.igd.fraunhofer.de/'>Fraunhofer Institute for Computer Graphics Research IGD</a> in Darmstadt, Germany. We provide expertise and technologies for visualization solutions tailored to users' data and tasks.",
      "AboutFunding": "This research work has been funded by the German Federal Ministry of Education and Research and the Hessian Ministry of Higher Education, Research, Science and the Arts within their joint support of the National Research Center for Applied Cybersecurity ATHENE.",
      "Acknowledgements": "Acknowledgements",
      "AcknowledgementsText": "This research was supported by the National Research Center for Applied Cybersecurity ATHENE. ATHENE is funded jointly by the German Federal Ministry of Research, Technology and Space and the Hessian Ministry of Science and Research, Arts and Culture.",
      "BarChartText": "In this visualization you can see at a glance from which category of data you have in relation to how many data points. This allows you to see which data is collected most frequently in your case and also identify differences between different online services or with the data of your friends.",
      "BarChartTitle": "Get a quick overview of the nature of your data",
      "ButtonDemo": "Explore sample data",
      "ButtonGo": "Use my own data",
      "ButtonLearn": "Learn more",
      "ButtonPrivacyPolicy": "Privacy Policy",
      "CollaborationText": "Please do not hesitate to contact us! We are interested in discussing how visual analytics can enhance your data analysis, privacy, or cybersecurity workflows.",
      "CollaborationTitle": "Interested in a demonstration, collaboration, or an applied research project?",
      "ContactUs": "Contact Us",
      "ContactUsText": "Contact: ",
      "ExplainTool": "No export? Open the sample data set and to view the visualizations. TransparencyVis is an active research prototype from Fraunhofer IGD and is free to use.",
      "ExploreNow": "Explore your personal data now!",
      "FeatureExploreText": "Explore your personal data using many different visualizations to make better decisions about your online behavior",
      "FeatureExploreTitle": "Explore",
      "FeatureLearnText": "Learn how to request your personal data downloads from multiple services!",
      "FeatureLearnTitle": "Learn",
      "FeaturePrivacyText": "Your personal data downloads are not shared with us and are not uploaded to any server or the internet.",
      "FeaturePrivacyTitle": "Private",
      "Features": "Features",
      "GDPRExport": "Your GDPR Export",
      "GridText": "The grid view makes it possible to view the data points in a chronological order, while still allowing to see many data points at the same time. This makes it easy to scan through the data to find specific data points or patterns.",
      "GridTitle": "A compact but detailed view of your data",
      "Header": "Visualize your personal data exports",
      "LoadDataNow": "Enter your data",
      "MoreDemos": "View other visualization demos from our research group",
      "NetworkGraphText": "For some services, especially where you have exchanged a lot of messages with other people, you can have a contact graph created in this visualization. Here you can see with whom and how much you have communicated over time.",
      "NetworkGraphTitle": "Have a look at your contact graph",
      "Participation": "With the participation of",
      "PieChartText": "In this visualization you can classify your data into three levels of sensitivity, depending on your perception. To do this, you can drag and drop the categories of data into the appropriate box. The distribution of your data is then displayed in the pie chart. Use the timeline above to select the time range that interests you. The displayed data is then filtered accordingly.",
      "PieChartTitle": "Get an idea of how much sensitive data your data set contains",
      "ProcessLeftAuxillary": "Nothing is ever uploaded to the internet",
      "ProcessLeftMain": "Your data is analyzed on your computer or phone",
      "ProcessRightAuxillary": "The goal of TransparencyVis is to help you protect your data",
      "ProcessRightMain": "Private by design",
      "ProvidersAvailable": "How to use",
      "ProvidersAvailableSubtitle": "To use TransparencyVis, you have to download your personal data with a GDPR right of access request. After you recieved your data you can enter it in TransparencyVis.  Instructions on services are available by clicking on the service below.",
      "ProvidersCustom": "Any other service that lets you export a .zip-archive with your data!",
      "Publications": "Publications",
      "PublicationsText": "TransparencyVis has appeared in at least the following publications:",
      "ResearchGroup": "About us",
      "SankeyText": "Discover for what purpose your data is used and who is it shared with through this visualization.",
      "SankeyTitle": "What happens to your data?",
      "SparklinesText": "This visualization gives you an overview of the chronological progression of selected data aspects. For example, you can see here in the news how the communication process with a certain person took place. So when you wrote more often and when you wrote less. You can also explore the history of various activities. The course of each aspect in a category is shown as a small curve. The more frequently the aspect occurred, the higher the peak. Use the timeline above to select the time range that interests you. The displayed data is then filtered accordingly.",
      "SparklinesTitle": "View histories of specific aspects of your data",
      "Subtitle": "Enter your GDPR data exports from Google, Instagram, Facebook or others, and explore it in interactive visualizations to improve your data awareness.",
      "SunBurstText": "The 'Behaviour & Inputs' visualization provides an overview of the distribution of your data points across different categories. This allows you to see which categories contain the most data points, and get an idea of what types of data are being collected by the services, and to what extent.",
      "SunBurstTitle": "See how your data is distributed",
      "ThesesTitle": "Student Theses",
      "TimelineText": "Use the timeline to visualize all your data points that can be assigned to a time. The x-axis shows years and months, while the y-axis shows the 24 hours of a single day. This allows you to spot trends and patterns in your online behavior. Use the mouse wheel to zoom into the view. Hover your mouse cursor over a data point to view details. By clicking on the categories in the right sidebar you can deselect the points for selected categories.",
      "TimelineTitle": "Explore temporal patterns in your data",
      "TreemapText": "The Files and Folders visualization provides an overview of the folders and files contained in your own data. The folders are each shown nested. The individual folders and files are colored so that you can see what type of file it is (e.g. image file, document, audio file, etc.). When moving the mouse over the tiles, additional information is displayed in the tooltip. By clicking on the header of a box you can zoom into the respective folder. If the files are images, these can also be displayed. By clicking on Category in the right sidebar, the files that contain further data points can also be displayed. The files are colored according to ten categories, depending on the type of data points (e.g. news, activities, locations, etc.).",
      "TreemapTitle": "Get an overview of the folders and files in your data",
      "TrustLocal": "Your files are not uploaded",
      "TrustNoAccount": "No account nor tracking of your data",
      "TrustResearch": "Peer-reviewed research prototype",
      "ViewsSubtitle": "Explore your data with different visualizations",
      "ViewsTitle": "Visualizations",
      "FAQ": {
        "Title": "Frequently Asked Questions",
        "items": [
          {
            "question": "What is TransparencyVis?",
            "answer": "TransparencyVis is a visualization interface that helps you explore personal-data exports from online services in a more understandable and interactive way."
          },
          {
            "question": "Is my data uploaded to a server?",
            "answer": "No, your data is processed locally in your browser. Data is not uploaded to the internet."
          },
          {
            "question": "What services are supported?",
            "answer": "TransparencyVis supports services that provide you with a .zip-archive with your data. Instructions for specific services are available."
          },
          {
            "question": "Is TransparencyVis free to use?",
            "answer": "Yes, TransparencyVis is a free research prototype developed by the Fraunhofer Institute for Computer Graphics Research IGD in Darmstadt, Germany."
          },
          {
            "question": "Which legal right allows me to request this data?",
            "answer": "Under Article 15 of the GDPR, you can request access to personal data held about you by an organization."
          },
          {
            "question": "Does using this service help me exercise my GDPR rights?",
            "answer": "No. TransparencyVis helps you inspect data that you have already received. You must request the export directly from the relevant online service."
          },
          {
            "question": "Does the visualization show everything the service knows about me?",
            "answer": "No. It only shows information contained in the export and successfully recognized by TransparencyVis. Providers may omit data, use inferred data, retain data, or provide incomplete exports."
          },
          {
            "question": "Can I use TransparencyVis on a mobile device?",
            "answer": "No. It is optimized for desktop use."
          }
        ]
      }
    },
    "AboutPage": {
      "Header": "A Visualization Interface to Improve the Transparency of Collected Personal Data on the Internet",
      "Abstract": "Abstract:",
      "AbstractText": "Online services are used for all kinds of activities, like news, entertainment, publishing content or connecting with others. But information technology enables new threats to privacy by means of global mass surveillance, vast databases and fast distribution networks. Current news are full of misuses and data leakages. In most cases, users are powerless in such situations and develop an attitude of neglect for their online behaviour. On the other hand, the GDPR (General Data Protection Regulation) gives users the right to request a copy of all their personal data stored by a particular service, but the received data is hard to understand or analyze by the common internet user. This paper presents TransparencyVis - a web-based interface to support the visual and interactive exploration of data downloads from different online services. With this approach, we aim at increasing the awareness of personal data stored by such online services and the effects of online behaviour. This design study provides an online accessible prototype and a best practice to unify data downloads from different sources.",
      "Published": "The paper has been published in",
      "Bibtex": "Show the BibTex for citation",
      "Preprint": "The paper has also been prepublished on",
      "Funded": "This research work has been funded by the German Federal Ministry of Education and Research and the Hessian Ministry of Higher Education, Research, Science and the Arts within their joint support of the National Research Center for Applied Cybersecurity ATHENE.",
      "Tips": "Short introduction to TransparencyVis",
      "TipsText": "With TransparencyVis you can visualize your personal data downloads from online services. You can learn how to request your data by utilizing your rights by the General Data Protection Regulation (GDPR). Add your data downloads from Google, Facebook, Twitter/X and others. The files included in the data download can be explored in a file visualization. The individual data elements which are generated by actions such as Likes, Posts or Messages can be viewed in a timeline. For more details, a list of all data elements can be viewed. TransparencyVis runs locally in your browser and no data is uploaded to our servers."
    },
    "DataPage": {
      "LoadedExports": "Loaded Data",
      "Files": "Files",
      "DataPoints": "Data Points",
      "Size": "Size",
      "WhichService": "Which Online Service do you want to use?",
      "ShowMeFirst": "show instructions for",
      "NotImported": "No data imported yet",
      "HowToRequest": "Learn how to request",
      "ImportedSuccessfully": "Data imported successfully",
      "DemoDatasetPre": "Try first with sample data set?",
      "DemoDataset": "Load sample Dataset",
      "DataExports": "Data Downloads",
      "AccessData": "How to access your data for ",
      "EnterData": "How to import your data here",
      "Tip": "Tip: You can also drag and drop your data download files anywhere on this page.",
      "NoDataFound": "No Data found. Import your data download or use the sample dataset on the service page.",
      "First": "How to access your data from",
      "ExploreActionButton": "Start Exploring Your Data",
      "Back": "Go Back",
      "VisitWebsiteFirst": "Visit",
      "VisitWebsiteSecond": "this website",
      "VisitWebsiteThird": "to request your personal data.",
      "SampleDataset": "Sample Dataset",
      "NoDataLeft": "Due to your filter settings no data is left. Adjust the filters.",
      "Wrangling": "Wrangle Data",
      "WranglingWithProvider": "Please upload a non-sample data set to start wrangling",
      "VisibleDatasets": "Visible Datasets",
      "InvisibleDatasets": "Invisible Datasets",
      "Count": "Count",
      "Of": "of",
      "NoDataAvailable": "No data available",
      "UnknownProviderSankey": "The provider was not recognized. Please upload a dataset from a known provider.",
      "ClickToEdit": "Click to Edit Exports",
      "Close": "Close",
      "UploadedExportsOf": "Uploaded Exports of",
      "DeleteExport": "Delete Export",
      "RenameExport": "Rename Export",
      "HideExport": "Hide this Export",
      "ShowExport": "Show this Export",
      "UnknownProvider": "Unknown Provider"
    },
    "Dropzone": {
      "Drop": "Drop your file here",
      "Error": "Error while parsing file",
      "ClickHere": "Click here to select your data download.",
      "Processed": "is being processed",
      "Loading": "Loading",
      "Loaded": "File successfully loaded",
      "Add": "You can also add more data downloads",
      "NoUpload": "No data will be uploaded. Your data stays on your device.",
      "Zip": "Please enter a zip file.",
      "Enter1": "Click here to select your",
      "Enter2": "file or add it via Drag & Drop",
      "WarningLargeFileTitle": "Import Large File?",
      "WarningLargeFile": "The data export you're about to import is very large. Processing might take a long time. Do you still want to proceed?",
      "ConfirmImport": "Yes, import",
      "AbortImport": "No, abort"
    },
    "Vis": {
      "TheFiles": "The Files in your Data download",
      "TheTimeline": "Timeline of your Data download",
      "Search": "Search",
      "ClearSearch": "Clear Search String",
      "TheGrid": "All Data Elements",
      "Sensitivity": "Sensitivity of your data:",
      "Rated": "Rated %num% of data elements",
      "DataExportsTitle": "Data downloads",
      "AddDataTitle": "Add Data",
      "DataExportsNonLoaded": "None loaded yet.",
      "ClickToHideExport": "Click to hide this export",
      "ClickToShowExport": "Click to show this export",
      "ExportFullName": "Full file name",
      "ExportNumberOfFiles": "Number of Files",
      "ExportFileSize": "File size",
      "CategoriesFilterTitle": "Filter Categories",
      "FileTypeFilterTitle": "Filter File Types",
      "ClickCategoryHide": "Click to hide this category",
      "ClickCategoryShow": "Click to show this category",
      "VisSettingsTitle": "Visualization Settings",
      "GlobalSettingsTitle": "Global Settings",
      "Provider": "Your Data",
      "Files": "Files and Folders",
      "TimeRangeSelection": "Select Time Range",
      "Timeline": "Timeline",
      "Grid": "Grid",
      "Barchart": "Barchart",
      "Dashboard": "Dashboard",
      "Sankey": "Dataflow",
      "SparkLines": "Category View",
      "PieChart": "Sensitive Data",
      "SunBurst": "Behaviour & Inputs",
      "Export": "Data Download",
      "PreviousPage": "Previous Page",
      "NextPage": "Next Page",
      "Page": "Page",
      "AscendingOrder": "Ascending Order",
      "DescendingOrder": "Descending Order",
      "Notice": "Notice: Please be aware, that the current state of the visualization does not necessarily cover all of your data.",
      "ContactGraph": "Contact Graph",
      "LocationHistory": "Location History",
      "Settings": "Settings",
      "Legal": "Legal Information",
      "Visualizations": "Visualizations",
      "Data": "Data",
      "from": "from",
      "FilterBoxTitle": "Filter by Message-Count",
      "NumberExchangedMessagesWith": "Number of exchanged Messages with",
      "FiltersActive": "Filters Active",
      "SensitivityLow": "Not Sensitive",
      "SensitivityMedium": "Partially Sensitive",
      "SensitivityHigh": "Sensitive",
      "PieChartChangeCategorySensitivity": "Drag the different categories between the columns to customize their sensitivity based on your judgement"
    },
    "Options": {
      "ShowMentalModels": "Show Mental Models",
      "HideSensitiveData": "Hide Sensitive Data",
      "ShowFolderHierarchy": "Show Folder Hierarchy",
      "ElementSize": "Element Size",
      "Grouping": "Group Smaller Items",
      "Search": "Search",
      "MultipleTimelines": "Multiple Timelines",
      "MultipleViews": "Multiple Views",
      "Amount": "Amount of Data Points",
      "ShowFiles": "Show Files",
      "ShowImages": "Show Images",
      "ColorScheme": "Color Scheme",
      "FileSize": "File Size",
      "DataPoints": "Data Points",
      "OnlyImages": "Only Images",
      "EqualSize": "Equal Size",
      "Categories": "Categories",
      "Subcategories": "Subcategories",
      "Provider": "Providers",
      "GoogleLocation": "Google Location Highlighting",
      "ScaleCircleSize": "Scale Circles to Text Length",
      "FullscreenOpen": "Enable Fullscreen",
      "FullscreenClose": "Disable Fullscreen",
      "FullscreenOpenShort": "Fullscreen",
      "FullscreenCloseShort": "Close",
      "SelectAll": "Select all",
      "DeselectAll": "Deselect all",
      "SwitchTheme": "Switch Theme",
      "LinearLayout": "Show as list",
      "ColumnCount": "Column Count",
      "SelectorItemOptions": {
        "category": "Category",
        "subcategory": "Subcategory",
        "provider": "Service",
        "location": "Location",
        "uncompressed": "File Size",
        "length": "Amount of Data",
        "evenly": "Evenly"
      }
    },
    "Categories": {
      "Account": "Account",
      "Activity": "Activity",
      "Contacts": "Contacts",
      "Messages": "Messages",
      "Other": "Other",
      "Location": "Location",
      "Likes": "Likes",
      "Stories": "Stories",
      "Posts": "Posts",
      "Media": "Media",
      "Security": "Security"
    },
    "FileCategories": {
      "Text": "Text File",
      "Picture": "Picture File",
      "Video": "Video File",
      "Audio": "Audio File",
      "Document": "Document",
      "Other": "Other File",
      "Account": "Account",
      "Location": "Location",
      "Media": "Media",
      "Activity": "Activity",
      "Contacts": "Contacts",
      "Messages": "Messages",
      "Stories": "Stories",
      "Likes": "Likes",
      "Posts": "Posts",
      "Security": "Security",
      "Files": "Files",
      "Categories": "Categories"
    },
    "ContactNetwork": {
      "Title": "The Contact Network from messages",
      "FilterInfo": [
        "The network graph is filtered with \n",
        "(1) the given period\n",
        "(2) the contacts interval (Min, Max)\n",
        "The links each of which has contacts\n",
        "less than Min or more than Max are dropped"
      ],
      "Reset": "RESET",
      "Apply": "APPLY",
      "User": "User",
      "Me": "Me",
      "Friend": "Friend",
      "numOfFriends": "My Friends ",
      "TotalMessages": "Total Messages",
      "Messages": "Messages",
      "ChartButton": "CONTACTS WITH",
      "None": "None"
    }
  },
  "de": {
    "name": "Deutsch",
    "type": "de-DE",
    "language": "Sprache",
    "UI": {
      "Home": "Startseite",
      "TransparencyVis": "TransparencyVis",
      "About": "Über uns",
      "Collapse": "Einklappen",
      "Expand": "Ausklappen",
      "ConfigSidebar": "Filter & Einstellungen",
      "ExpandConfigSidebar": "Fortgeschrittene Optionen Einblenden",
      "Imprint": "Impressum",
      "PrivacyPolicy": "Datenschutz",
      "Settings": "Einstellung",
      "NotFound": "Website nicht gefunden",
      "Wrangler": "Daten Wrangeln",
      "Explore": "Zu den Visualisierungen",
      "NextVisualization": "Nächste Visualisierung",
      "PreviousVisualization": "Vorherige Visualisierung",
      "AddData": "Mehr Daten hinzufügen",
      "Help": "Hilfe",
      "VisualizationHelp": "Bekomme Information zu dieser Visualisierung"
    },
    "LandingPage": {
      "Header": "Visualisiere deine persönlichen Daten",
      "Subtitle": "TransparencyVis visualisiert deine persönlichen Datenexporte von verschiedenen Online-Diensten, um dein Bewusstsein für deine Daten zu schärfen.",
      "ProcessLeftMain": "Deine Daten werden auf deinem Computer oder Handy analysiert",
      "ProcessLeftAuxillary": "Nichts wird jemals ins Internet hochgeladen",
      "ProcessRightMain": "Für Privatsphäre designed",
      "ExplainTool": "Keine Datenexporte zur Hand? Öffne den Beispieldatensatz um die interaktiven Visualiserungen auszuprobieren. TransparencyVis ist ein aktives Forschungsprojekt und kostenlos nutzbar.",
      "ProcessRightAuxillary": "Das Ziel von TransparencyVis ist es, dir zu helfen, deine Daten zu schützen",
      "Features": "Funktionen",
      "TrustLocal": "Deine Dateien verlassen nie dein Gerät",
      "TrustNoAccount": "TransparencyVis benötigt kein Konto oder persönliche Informationen",
      "TrustResearch": "publizierter Forschungsprototyp",
      "ButtonDemo": "Beispieldatensatz erkunden",
      "ViewsTitle": "Visualisierungen",
      "ViewsSubtitle": "Erkunde deine Daten mit verschiedenen Visualisierungen",
      "ThesesTitle": "Thesen",
      "Acknowledgements": "Danksagungen",
      "AcknowledgementsText": "Diese Forschung wurde vom National Research Center for Applied Cybersecurity ATHENE unterstützt. ATHENE wird gemeinsam vom deutschen Bundesministerium für Forschung, Technologie und Raumfahrt und dem Hessischen Ministerium für Wissenschaft und Forschung, Künste und Kultur finanziert.",
      "ResearchGroup": "Über das Forschungsgruppe",
      "MoreDemos": "Siehe andere Visualisierungs-Demos von unserer Forschungsgruppe",
      "CollaborationText": "Zögern Sie bitte nicht uns zu kontaktieren! Wir sind interessiert im Gespräch zu diskutieren wie Visual Analytics ihre Datenanalyse, Privatssphäre, or Cybersecurity Anwendungen verbessern.",
      "CollaborationTitle": "Interessiert an einer Demonstration, Zusammenarbeit oder einem angewandten Forschungsprojekt?",
      "FeatureFilter": "In der linken Seitenleiste kannst du Kategorien filtern und zusätzliche Einstellungen vornehmen.",
      "FeatureLearnTitle": "Lernen",
      "FeatureLearnText": "Erfahre, wie du deine persönlichen Datenexporte von mehreren Online-Diensten anfordern kannst!",
      "FeaturePrivacyTitle": "Sicher",
      "FeaturePrivacyText": "Deine persönlichen Datenexporte werden nicht mit uns geteilt und nicht ins Internet hochgeladen.",
      "FeatureExploreTitle": "Entdecke",
      "FeatureExploreText": "Erkunde deine persönlichen Daten mit vielen verschiedenen Visualisierungen, um bessere Entscheidungen über dein Online-Verhalten zu treffen.",
      "ProvidersAvailable": "Unterstützte Online-Dienste",
      "ProvidersAvailableSubtitle": "Klicke auf einen Dienst für Anleitungen, wie du deine Daten anfordern kannst",
      "ProvidersCustom": "Jeder andere Dienst, der dir erlaubt, ein .zip-Archiv mit deinen Daten zu exportieren!",
      "TimelineTitle": "Erkunde zeitliche Zusammenhänge in deinen Daten",
      "TimelineText": "Verwende die Zeitachse, um alle deine Datenpunkte, die einer Zeit zugeordnet werden können, zu visualisieren. Die x-Achse zeigt Jahre und Monate, während die y-Achse die 24 Stunden eines einzelnen Tages anzeigt. Auf diese Weise kannst du Trends und Muster in deinem Online-Verhalten erkennen. Benutze das Mausrad um in die Ansicht zu zoomen. Bewege deinen Mauszeiger über einen Datenpunkt um Details anzuzeigen. Durch Klicken auf die Kategorien in der rechten Seitenleiste kannst du die Punkte für ausgewählte Kategorien abwählen.",
      "TreemapTitle": "Verschaffe dir einen Überblick über die Ordner und Dateien in deinen Daten",
      "TreemapText": "Die Visualisierung „Dateien und Ordner“ gibt eine Übersicht über die in den eigenen Daten enthaltenen Ordner und Dateien. Dabei sind die Ordner jeweils verschachtelt dargestellt. Die einzelnen Ordner und Dateien sind farblich eingefärbt, sodass man erkennen kann um welche Art der Datei es sich handelt (Beispielsweise Bild Datei, Dokument, Audio Datei, etc.). Beim Bewegender Maus über die Kacheln werden zusätzliche Informationen im Tooltip angezeigt. Durch Klicken auf den Kopfteil eines Kastens kann man in den jeweiligen Ordner hineinzoomen. Handelt es sich bei den Dateien um Bilder, können diese ebenfalls eingeblendet werden.  Durch Klicken auf Category in der rechte Seitenleiste können zusätzlich die Dateien angezeigt werden, die weitere Datenpunkte enthalten. Dabei werden die Dateien entsprechend zehn Kategorien eingefärbt, je nachdem um welche Art von Datenpunkten es sich handelt (Beispielsweise Nachrichten, Aktivitäten, Standorte, etc.).",
      "SparklinesTitle": "Schaue dir die Verläufe von bestimmten Aspekten deiner Daten an",
      "SparklinesText": "In dieser Visualisierung bekommst du einen Überblick über zeitliche Verläufe von ausgewählten Datenaspekten. Beispielsweise kannst du hier in den Nachrichten anschauen, wie der Kommunikationsverlauf mit einer bestimmten Person stattgefunden hat. Also, wann ihr häufiger und wann ihr seltener geschrieben habt. Auch kannst du die Verläufe von verschiedenen Aktivitäten erkunden. Dabei ist für jeden Aspekt in einer Kategorie der Verlauf als eine kleine Kurve dargestellt. Je häufiger der Aspekt vorkam, desto höher ist der Piek. Mit der Zeitleiste oben kannst du den Zeitbereich auswählen, der dich interessiert. Daraufhin werden die angezeigten Daten entsprechend gefiltert.",
      "PieChartTitle": "Mache dir ein Bild darüber, wie viele sensitive Daten dein Datensatz enthält",
      "PieChartText": "In dieser Visualisierung kannst du deine Daten in drei Stufen von Sensibilität einteilen, je nachdem wie es deiner Wahrnehmung entspricht. Dazu kannst du die Kategorien der Daten per Drag&Drop jeweils in die entsprechende Box ziehen. In dem Kuchendiagramm wird dir dann die Verteilung deiner Daten dargestellt. Mit der Zeitleiste oben kannst du den Zeitbereich auswählen, der dich interessiert. Daraufhin werden die angezeigten Daten entsprechend gefiltert.",
      "NetworkGraphTitle": "Sieh dir deinen Kontaktgraphen an",
      "NetworkGraphText": "Für manche Dienste, insbesondere bei denen du viele Nachrichten mit anderen Menschen ausgetauscht hast, kannst du dir in dieser Visualisierung einen Kontaktgraphen erstellen lassen. Hier siehst du mit wem und wie viel du im Laufe der Zeit kommuniziert hast.",
      "BarChartTitle": "Bekomme einen schnellen Überblick die Art deiner Daten ",
      "BarChartText": "In dieser Visualisierung kannst du auf einen Blick sehen, von welcher Kategorie an Daten du im Verhältnis wie viele Datenpunkte hast. Dadurch kannst du sehen, welche Daten in deinem Fall am häufigsten gesammelt werden und auch Unterschiede zwischen verschiedenen Online-Diensten oder mit den Daten deiner Freunde feststellen.",
      "GridTitle": "Eine kompakte aber detaillierte Ansicht deiner Daten",
      "GridText": "Die Rasteransicht macht es möglich, die Datenpunkte in einer chronologischen Reihenfolge anzusehen, während es trotzdem noch möglich ist viele Datenpunkte gleichzeitig zu sehen. Dadurch ist es einfach durch die Daten zu scannen um spezifische Datenpunkte oder Muster zu finden.",
      "SankeyTitle": "Was passiert mit Ihren Daten?",
      "SankeyText": "Die Visualisierung gibt Ihnen einen Überblick darüber, wofür Ihre Daten verwendet und an wen sie weitergegeben werden.",
      "SunBurstTitle": "Sieh dir an, wie deine Daten aufgeteilt sind",
      "SunBurstText": "Die Visualisierung „Verhalten & Inputs“ gibt einen Überblick über die Verteilung deiner Datenpunkte über verschiedene Kategorien. Dadurch kannst du sehen, welche Kategorien die meisten Datenpunkte enthalten und dir ein Bild davon machen, welche Arten von Daten von den Diensten gesammelt werden und in welchem Umfang.",
      "ExploreNow": "Erkunde jetzt deine persönlichen Daten!",
      "About": "Über das Projekt",
      "AboutDevelopment": "Die Entwicklung von TransparencyVis wird vom Kompetenzzentrum für <a href='https://www.igd.fraunhofer.de/kompetenzen/technologien/informationsvisualisierung'>Informationsvisualisierung und Visual Analytics</a> des <a href='https://www.igd.fraunhofer.de/'>Fraunhofer-Instituts für Graphische Datenverarbeitung IGD</a> in Darmstadt, Deutschland, geleitet. Das Fraunhofer IGD ist die international führende Einrichtung für angewandte Forschung im Visual Computing. Das Kompetenzzentrum für Informationsvisualisierung bietet Expertise und innovative Technologien, wodurch neuartige Visualisierungslösungen direkt auf die Daten und Aufgaben der Nutzer zugeschnitten werden.",
      "AboutFunding": "Diese Forschungsarbeit wurde vom Bundesministerium für Bildung und Forschung (BMBF) und vom Hessischen Ministerium für Wissenschaft und Kunst (HMWK) im Rahmen ihrer gemeinsamen Förderung für das Nationale Forschungszentrum für angewandte Cybersicherheit ATHENE unterstützt.",
      "Publications": "Publikationen",
      "PublicationsText": "TransparencyVis ist mindestens in den folgenden Publikationen erschienen:",
      "Participation": "Unter Mitwirkung von",
      "ContactUs": "Kontaktiere uns",
      "ContactUsText": "Wir freuen uns über jedes Feedback. Kontaktiere uns gerne unter",
      "ButtonGo": "Jetzt Erkunden!",
      "LoadDataNow": "Deine Daten einfügen",
      "ButtonPrivacyPolicy": "Datenschutzerklärung",
      "ButtonLearn": "Mehr erfahren",
      "GDPRExport": "Dein DSGVO-Export",
      "FAQ": {
        "Title": "Häufig gestellte Fragen",
        "items": [
          {
            "question": "Was ist TransparencyVis?",
            "answer": "TransparencyVis ist eine Visualisierungsoberfläche, mit der Sie Datenexporte personenbezogener Daten von Online-Diensten auf verständlichere und interaktive Weise erkunden können."
          },
          {
            "question": "Werden meine Daten auf einen Server hochgeladen?",
            "answer": "Nein, Ihre Daten werden lokal in Ihrem Browser verarbeitet. Die Daten werden nicht ins Internet hochgeladen."
          },
          {
            "question": "Welche Dienste werden unterstützt?",
            "answer": "TransparencyVis unterstützt Dienste, die Ihnen ein ZIP-Archiv mit Ihren Daten bereitstellen. Anleitungen für bestimmte Dienste sind verfügbar."
          },
          {
            "question": "Ist die Nutzung von TransparencyVis kostenlos?",
            "answer": "Ja, TransparencyVis ist ein kostenloser Forschungsprototyp, der vom Fraunhofer-Institut für Graphische Datenverarbeitung IGD in Darmstadt entwickelt wurde."
          },
          {
            "question": "Welches gesetzliche Recht ermöglicht es mir, diese Daten anzufordern?",
            "answer": "Gemäß Artikel 15 der DSGVO können Sie Auskunft über die personenbezogenen Daten verlangen, die eine Organisation über Sie gespeichert hat."
          },
          {
            "question": "Hilft mir die Nutzung dieses Dienstes dabei, meine Rechte nach der DSGVO auszuüben?",
            "answer": "Nein. TransparencyVis hilft Ihnen dabei, Daten zu untersuchen, die Sie bereits erhalten haben. Den Datenexport müssen Sie direkt beim jeweiligen Online-Dienst anfordern."
          },
          {
            "question": "Zeigt die Visualisierung alles, was der Dienst über mich weiß?",
            "answer": "Nein. Sie zeigt nur Informationen, die im Export enthalten sind und von TransparencyVis erfolgreich erkannt werden. Anbieter können Daten auslassen, abgeleitete Daten verwenden, Daten weiterhin speichern oder unvollständige Exporte bereitstellen."
          },
          {
            "question": "Kann ich TransparencyVis auf einem mobilen Gerät verwenden?",
            "answer": "Nein. TransparencyVis ist für die Nutzung auf Desktop-Computern optimiert."
          }
        ]
      }
    },
    "AboutPage": {
      "Header": "Eine visuelle Benutzeroberfläche zur Verbesserung der Transparenz von gesammelten persönlichen Daten im Internet",
      "Abstract": "Abstract:",
      "AbstractText": "Online-Dienste werden für alle möglichen Aktivitäten genutzt, wie Nachrichten, Unterhaltung, Veröffentlichung von Inhalten oder Kontaktaufnahme mit anderen. Die Informationstechnologie ermöglicht jedoch neue Bedrohungen der Privatsphäre durch globale Massenüberwachung, riesige Datenbanken und schnelle Verbreitungsnetze. Die aktuellen Nachrichten sind voll von Missbrauch und Datenlecks. In den meisten Fällen sind die Nutzer in solchen Situationen machtlos und entwickeln eine Haltung der Nachlässigkeit gegenüber ihrem Online-Verhalten. Andererseits gibt die Datenschutz-Grundverordnung (DSGVO) den Nutzern das Recht, eine Kopie aller von einem bestimmten Dienst gespeicherten persönlichen Daten anzufordern, aber die erhaltenen Daten sind für den normalen Internetnutzer schwer zu verstehen oder zu analysieren. In diesem Beitrag wird TransparencyVis vorgestellt - eine webbasierte Schnittstelle zur Unterstützung der visuellen und interaktiven Erkundung von Datenexporten aus verschiedenen Online-Diensten. Mit diesem Ansatz wollen wir das Bewusstsein für persönliche Daten, die von solchen Online-Diensten gespeichert werden, und die Auswirkungen des Online-Verhaltens schärfen. Diese Designstudie bietet einen online zugänglichen Prototyp und eine bewährte Methode zur Vereinheitlichung von Datenexporten aus verschiedenen Quellen.",
      "Published": "Die Fachpublikation wurde veröffentlicht in",
      "Bibtex": "BibTex für die Zitation anzeigen",
      "Preprint": "Die Arbeit wurde auch vorveröffentlicht auf",
      "Funded": "Diese Forschungsarbeit wurde vom Bundesministerium für Bildung und Forschung (BMBF) und vom Hessischen Ministerium für Wissenschaft und Kunst (HMWK) im Rahmen ihrer gemeinsamen Förderung für das Nationale Forschungszentrum für angewandte Cybersicherheit ATHENE unterstützt.",
      "Tips": "Tipps zur Verwendung dieser Anwendung",
      "TipsText": "Mit TransparencyVis kannst du den Export deiner personenbezogenen Daten aus Online-Diensten visualisieren. Du kannst lernen, wie du deine Daten anfordern kannst, indem du deine Rechte gemäß der Datenschutz-Grundverordnung (DSGVO) nutzt. Füge deine Datenexporte von Google, Facebook, Twitter/X und anderen hinzu. Die im Datenexport enthaltenen Dateien können in einer Dateivisualisierung erkundet werden. Die einzelnen Datenelemente, die durch Aktionen wie Likes, Posts oder Nachrichten erzeugt werden, können in einer Zeitleiste betrachtet werden. Für weitere Details kann eine Liste aller Datenelemente eingesehen werden. TransparencyVis läuft lokal in Ihrem Browser und es werden keine Daten auf unsere Server hochgeladen."
    },
    "DataPage": {
      "LoadedExports": "Geladene Exporte",
      "Files": "Dateien",
      "DataPoints": "Datenpunkte",
      "Size": "Größe",
      "WhichService": "Welchen Online-Dienst möchtest du ansehen?",
      "ShowMeFirst": "Anleitung zeigen für",
      "NotImported": "Noch nicht importiert",
      "HowToRequest": "Erfahre, wie man Daten anfordert",
      "ImportedSuccessfully": "Daten erfolgreich geladen",
      "DemoDatasetPre": "Zuerst mit Demodatensatz ausprobieren?",
      "DemoDataset": "Test-Datensatz laden",
      "DataExports": "Daten-Exporte",
      "AccessData": "Wie du auf deine Daten zugreifen kannst",
      "EnterData": "Wie du deine Daten hier hinzufügen kannst",
      "Tip": "Tipp: Du kannst deine Datenexportdateien auch per Drag & Drop auf dieser Seite ablegen.",
      "NoDataFound": "Keine Daten gefunden. Füge einen Datenexport hinzu oder verwende den Demo-Datensatz.",
      "First": "Wie du auf deine Daten zugreifen kannst",
      "ExploreActionButton": "Beginne deine Daten zu erkunden",
      "Back": "Zurück",
      "VisitWebsiteFirst": "Besuche",
      "VisitWebsiteSecond": "diese Website",
      "VisitWebsiteThird": "um deine persöhnlichen Daten anzufordern.",
      "SampleDataset": "Test-Datensatz",
      "NoDataLeft": "Aufgrund der Filter sind keine Daten mehr übrig. Passe die Filter an.",
      "Wrangling": "Daten Wranglen",
      "WranglingWithProvider": "Bitte lade einen Nicht-Demo-Datensatz hoch, um mit dem Wranglen zu beginnen.",
      "VisibleDatasets": "Sichtbare Datensätze",
      "InvisibleDatasets": "Unsichtbare Datensätze",
      "Count": "Anzahl",
      "Of": "von",
      "NoDataAvailable": "Keine Daten gefunden",
      "UnknownProviderSankey": "Unbekannter Dienst. Bitte laden Sie Daten eines bekannten Dienstes hoch.",
      "ClickToEdit": "Klicken um Exporte zu bearbeiten",
      "Close": "Schließen",
      "UploadedExportsOf": "Hochgeladene Exporte von",
      "DeleteExport": "Export löschen",
      "RenameExport": "Export umbenennen",
      "HideExport": "Diesen Export verstecken",
      "ShowExport": "Diesen Export anzeigen",
      "UnknownProvider": "Unbekannter Dienst"
    },
    "Dropzone": {
      "Drop": "Lege die Datei hier ab",
      "Error": "Fehler beim lesen der Datei",
      "ClickHere": "Hier klicken um Datenexport auszuwählen.",
      "Processed": "wird gerade verarbeitet",
      "Loading": "Wird geladen",
      "Loaded": "Datei erfolgreich geladen",
      "Add": "Du kannst auch weitere Dateien hinzufügen",
      "NoUpload": "Die Daten werden lokal auf deinem Rechner verarbeitet und nicht ins Internet geladen.",
      "Zip": "Bitte füge eine Zip-Datei hinzu.",
      "Enter1": "Hier klicken um eine",
      "Enter2": "Datei auszuwählen oder einfach mittels Drag&Drop reinziehen.",
      "WarningLargeFileTitle": "Große Datei importieren?",
      "WarningLargeFile": "Der ausgewählte Daten-Export ist sehr groß, und die Verarbeitung könnte eine Weile dauern. Möchtest du den Export trotzdem importieren?",
      "ConfirmImport": "Ja, importieren",
      "AbortImport": "Nein, abbrechen"
    },
    "Vis": {
      "TheFiles": "Die Dateien in deinem Datenexport",
      "TheTimeline": "Zeitstrahl all deiner Daten",
      "Search": "Suche",
      "ClearSearch": "Suchbegriff löschen",
      "TheGrid": "Alle Datenelemente",
      "Sensitivity": "Sensibilität der Daten",
      "Rated": "%num% der Daten Elemente bewertet",
      "DataExportsTitle": "Daten-Exporte",
      "AddDataTitle": "Daten Hinzufügen",
      "DataExportsNonLoaded": "Noch keine geladen.",
      "ClickToHideExport": "Hier klicken um den Datenexport zu verbergen",
      "ClickToShowExport": "Hier klicken um den Datenexport zu zeigen",
      "ExportFullName": "Vollständiger Name des Exports",
      "ExportNumberOfFiles": "Anzahl der Dateien",
      "ExportFileSize": "Dateigröße",
      "CategoriesFilterTitle": "Kategorien Filtern",
      "FileTypeFilterTitle": "Dateitypen Filtern",
      "ClickCategoryHide": "Hier klicken um die Kategorie zu verbergen",
      "ClickCategoryShow": "Hier klicken um die Kategorie zu zeigen",
      "VisSettingsTitle": "Visualisierungs-Optionen",
      "GlobalSettingsTitle": "Allgemeine Optionen",
      "Provider": "Deine Daten",
      "Files": "Dateien und Ordner",
      "TimeRangeSelection": "Zeitraum auswählen",
      "Timeline": "Zeitstrahl",
      "Grid": "Raster",
      "Barchart": "Säulendiagramm",
      "Dashboard": "Übersicht",
      "SparkLines": "Kategorien",
      "PieChart": "Sensible Daten",
      "Sankey": "Datenfluss",
      "SunBurst": "Verhalten & Inputs",
      "Export": "Exportieren",
      "PreviousPage": "Vorherige Seite",
      "NextPage": "Nächste Seite",
      "Page": "Seite",
      "AscendingOrder": "Absteigende Sortierung",
      "DescendingOrder": "Aufsteigende Sortierung",
      "Notice": "Hinweis: Der aktuelle Stand der Visualisierung zeigt nicht unbedingt alle Daten an.",
      "ContactGraph": "Kontakt-Graph",
      "LocationHistory": "Standortverlauf",
      "Settings": "Einstellungen",
      "Legal": "Rechtliches",
      "Visualizations": "Visualisierungen",
      "Data": "Daten",
      "from": "von",
      "FilterBoxTitle": "Filter nach Anzahl der Nachrichten",
      "NumberExchangedMessagesWith": "Anzahl der ausgetauschten Nachrichten mit",
      "FiltersActive": "Filter Aktiv",
      "SensitivityLow": "Nicht Sensitiv",
      "SensitivityMedium": "Teilweise Sensitiv",
      "SensitivityHigh": "Sensitiv",
      "PieChartChangeCategorySensitivity": "Verschiebe die Kategorien zwischen den Spalten um ihre Sensitivität entsprechend deiner Einschätzung anzupassen"
    },
    "Options": {
      "ShowMentalModels": "Mentale Modelle anzeigen",
      "HideSensitiveData": "Sensible Daten ausblenden",
      "ShowFolderHierarchy": "Ordner-Hierarchie einblenden",
      "ElementSize": "Elementen Größe",
      "Grouping": "Kleinere Elemente gruppieren",
      "Search": "Suche",
      "MultipleTimelines": "Mehrere Timelines",
      "MultipleViews": "Mehrere Ansichten",
      "Amount": "Anzahl der Daten Elemente",
      "ShowFiles": "Dateien anzeigen",
      "ShowImages": "Bilder anzeigen",
      "ColorScheme": "Farbschema",
      "FileSize": "Datei Größe",
      "DataPoints": "Datenpunkte",
      "OnlyImages": "Nur Bilder",
      "EqualSize": "Gleichgroß",
      "Categories": "Kategorien",
      "Subcategories": "Unterkategorien",
      "Provider": "Online-Dienste",
      "GoogleLocation": "Google Standort Daten hervorheben",
      "ScaleCircleSize": "Größe an Textlänge anpassen",
      "FullscreenOpen": "Vollbildmodus aktivieren",
      "FullscreenClose": "Vollbildmodus beenden",
      "FullscreenOpenShort": "Vollbildmodus",
      "FullscreenCloseShort": "Schließen",
      "SelectAll": "Alle auswählen",
      "DeselectAll": "Alle abwählen",
      "SwitchTheme": "Farbschema ändern",
      "LinearLayout": "Als Liste anzeigen",
      "ColumnCount": "Anzahl Spalten",
      "SelectorItemOptions": {
        "category": "Kategorie",
        "subcategory": "Unterkategorie",
        "provider": "Online-Dienst",
        "location": "Standort",
        "uncompressed": "Dateigröße",
        "length": "Anzahl an Datenpunkten",
        "evenly": "Gleichgroß"
      }
    },
    "Categories": {
      "Account": "Konto",
      "Activity": "Aktivitäten",
      "Contacts": "Kontakte",
      "Messages": "Nachrichten",
      "Location": "Standort",
      "Other": "Andere",
      "Likes": "Likes",
      "Media": "Medien",
      "Posts": "Beiträge",
      "Security": "Sicherheit"
    },
    "FileCategories": {
      "Text": "Text Datei",
      "Picture": "Bild Datei",
      "Video": "Video Datei",
      "Audio": "Audio Datei",
      "Document": "Dokument",
      "Other": "Anderer Dateityp",
      "Media": "Medien",
      "Account": "Konto",
      "Activity": "Aktivitäten",
      "Contacts": "Kontakte",
      "Location": "Standort",
      "Messages": "Nachrichten",
      "Likes": "Likes",
      "Posts": "Beiträge",
      "Security": "Sicherheit",
      "Files": "Dateien",
      "Categories": "Kategorien"
    },
    "ContactNetwork": {
      "Title": "Das Kontaktnetzwerk aus Nachrichten",
      "FilterInfo": [
        "Der Netzwerkgraph wird gefiltert\n",
        "(1) mit der angegebenen Periode\n",
        "(2) mit dem Kontaktintervall (Min, Max)\n",
        "Die Links werden gelöscht, die jeweils \n",
        "weniger als Min oder mehr als Max Kontakte haben"
      ],
      "Reset": "ZURÜCK",
      "Apply": "Anwenden",
      "User": "Benutzer",
      "Me": "Mich",
      "Friend": "Freund",
      "numOfFriends": "Meine Freunde",
      "TotalMessages": "Gesamte Nachrichten",
      "Messages": "Nachrichte",
      "ChartButton": "Kontakte mit",
      "None": "Keiner"
    }
  }
}
